import { api } from './client';

export type RegistrationStatus = 'registered' | 'waitlisted' | 'confirmed' | 'attended' | 'no_show' | 'cancelled';

export interface MyEventAttendee {
  attendeeId: string;
  attendeeName?: string;
  registrationStatus: RegistrationStatus;
  checkedInAt?: string;
  checkedOutAt?: string;
  confirmedAt?: string;
  cancelledAt?: string;
}

export interface MyEvent {
  eventId: string;
  eventName: string;
  eventDate: string;
  location?: string;
  attendees: MyEventAttendee[];
}

export interface MyEventsResponse {
  events: MyEvent[];
  total: number;
}

export class MyEventsService {
  static async getPastEvents(): Promise<MyEventsResponse> {
    return api.get<MyEventsResponse>('/my-events/past');
  }

  static async getUpcomingEvents(params?: Record<string, unknown>): Promise<MyEventsResponse> {
    const searchParams = new URLSearchParams();

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          // Special handling for statuses to match backend filter format
          if (key === 'statuses' && Array.isArray(value)) {
            searchParams.append('filter.registrationStatus', `$in:${value.join(',')}`);
          } else {
            searchParams.append(key, String(value));
          }
        }
      });
    }

    const queryString = searchParams.toString();
    const url = queryString ? `/my-events/upcoming?${queryString}` : '/my-events/upcoming';
    return api.get<MyEventsResponse>(url);
  }

  static async checkOut(eventId: string, attendeeId: string): Promise<void> {
    await api.post(`/member-events/${eventId}/registrations/${attendeeId}/check-out`);
  }

  static async cancelRegistration(eventId: string, reason: string): Promise<{ cancelledCount: number }> {
    return api.post(`/member-events/${eventId}/registrations/cancel`, { reason });
  }
}
